import './_loading.scss'

export default function LoadingAnimation() {
  return (
    <div className="loading">
      <div className="loading-spinner" />
      <div className="loading-text">
        {'Usman Arif'.split('').map((ch, i) => (
          <span key={i}>{ch === ' ' ? ' ' : ch}</span>
        ))}
      </div>
    </div>
  )
}
